(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    const annBarSwiper = annBar.querySelector('.announcement-bar.swiper:not(.swiper-initialized)');

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              if( annBarSwiper ){
                var swiper = new Swiper(annBarSwiper, {
                  slidesPerView: 'auto',
                  spaceBetween: 0,        
                  loop: true,
                  speed: 600,
                  // autoplay: {
                  //   delay: 2500,
                  //   disableOnInteraction: false,
                  // },
                  // cssMode: true,
                  // centeredSlides: true,
                  navigation: {
                    nextEl: ".swiper-ann-btn-next",
                    prevEl: ".swiper-ann-btn-prev",
                  },
                  breakpoints: {          
                    0: {
                      slidesPerView: 1,
                      centeredSlides: true,
                    },
                    750: {
                      slidesPerView: 'auto',
                      centeredSlides: false,
                      speed: 600,
                    },
                  },
                  on: {
                    init: function (swiper) {
                      // console.log('announcement_sliers swiper initialized');
                      setNavArrowPosition(swiper);
                    },
                    slideChangeTransitionStart: function (swiper) {                        
                      setNavArrowPosition(swiper);            
                    },
                  },
                });
              }
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();

  function setNavArrowPosition(swiper){
    if( swiper.el.querySelector('.swiper-slide-active .announcement-msg') && window.innerWidth > 749 ){
      let offsetLeft = swiper.el.querySelector('.swiper-slide-active .announcement-msg').offsetLeft - 40;      
      swiper.el.querySelector('.swiper-ann-btn-prev').style.left = offsetLeft+'px';
      swiper.el.querySelector('.swiper-ann-btn-next').style.right = offsetLeft+'px';
    }else{
      swiper.el.querySelector('.swiper-ann-btn-prev').style.left = '';
      swiper.el.querySelector('.swiper-ann-btn-next').style.right = '';
    }
  }
})();